//import fionn from '../src/assets/images/fionn.jpg';
//import fancyFionn from '../src/assets/images/fancy-fionn.jpg';
import '../src/info.css'

// NOTE: The infobox component allows for dangerouslyinnerhtml, so use it.
const info = [
//        {
//        id: '1',
//        title: 'About Me',
//        text: 'Hey, my name is Fionn Camacho Lenihan, and I\'m a Software Engineer. I am currently ' +
//        'in my fourth and final year at Trinity College Dublin, Majoring in Computer Science.' +
//        '<br><br>' +
//        'I have a background in web/mobile application development, but have completed a number of low-level programming projects, too. ' +
//        'I have a great interest in Software Engineering in general, but especially love problems and jobs that make me apply myself. ' +
//        '<br><br>' +
//        'I am constantly completing projects for both personal enjoyment, and for work/college, which you can see above. ' +
//        'If you have any queries please feel free contact me at one of my socials in the navbar.',
//        image: fancyFionn,
//        imageAlt: 'A headshot of me.'
//},
//{
//        id: '2',
//        title: 'Skills',
//        text: 'As briefly mentioned in the last section, I have experience in HTML, CSS, JavaScript and most other languages required for web development. ' +
//        'I have extensive experience involving API creation and usage. I have experience with both Flask in Python and ExpressJS in JavaScript and I have a good understanding ' +
//        'of how APIs can be used and operate. ' +
//        '<br><br>' +
//        'I can adapt extremely fast and understand complicated ideas and processes faster than the average person, when it comes to Computer Science, at least. ' +
//        'All of my jobs and projects have required me to work in a team, and I have proven myself to be capable of working with others, even excelling at it. ' +
//        'Finally, the most important skill I have when it comes to Software Development is my <b>passion</b>. I love programming and have always loved it, starting from a young age, ' +
//        'and I will continue to love it far into the future.' +
//        '<br><br>' +
//        '<i>Technology is constantly changing, and I can guarantee I\'m always adapting with it!</i>',
//        image: fionn,
//        imageAlt: 'Me fake-fighting with a cardboard cutout of Dagestani influencer and fighter "Hasbullah". '
//},
]

export default info;
